import React, { useContext, useEffect, useState, useCallback } from "react";
import { StudentsList, SelectionArea } from "../../pages/Integrante/styles";
import { SelectDate } from "../SelectDate";
import { IntegranteItem } from "../IntegranteItem/IntegranteItem";
import { getStudentsByClassroom } from "../../api/sponteAPI";
import { ClassroomSelect } from "../ClassroomSelect";
import { getRoutinesByDate } from "../../api/autenticoAPI";
import { AuthContext } from "../../contexts/Auth/AuthContext";
import { Loading } from "../Loading/Loading";
import { normalizeStudentsByClassroom } from "../../utils/sponteDataNormalizer";
import SelectSys from "../Systech/SelectSys/SelectSys";

export const IntegranteRotinas = () => {
  const [date, setDate] = useState(new Date());
  const [students, setStudents] = useState([]);
  const [classrooms, setClassrooms] = useState([]);
  const [partialData, setPartialData] = useState([]);
  const [updateList, setUpdateList] = useState(false);
  const [loading, setLoading] = useState(false);
  const auth = useContext(AuthContext);
  
  // Ano letivo - inicializar com o ano atual (mínimo 2025, máximo 2026)
  const currentYear = new Date().getFullYear();
  const [anoLetivo, setAnoLetivo] = useState(
    currentYear >= 2026 ? 2026 : currentYear >= 2025 ? currentYear : 2025
  );

  const fetchStudents = useCallback(async (selectedClassroom) => {
    try {
      setLoading(true);
      const res = await getStudentsByClassroom(selectedClassroom);
      const normalizedStudents = normalizeStudentsByClassroom(res);
      setStudents(normalizedStudents);
    } catch (error) {
      console.error("Erro ao buscar estudantes:", error);
      setStudents([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchRoutines = useCallback(async (selectedDate) => {
    try {
      const formattedDate = selectedDate.toISOString().split("T")[0];
      const res = await getRoutinesByDate(formattedDate);
      setPartialData(Array.isArray(res) ? res : []);
    } catch (error) {
      console.error("Erro ao buscar rotinas:", error);
      setPartialData([]);
    }
  }, []);

  const updateRoutineList = useCallback(async () => {
    if (classrooms.length > 0) {
      await fetchStudents(classrooms[1]);
    }
    await fetchRoutines(date);
  }, [classrooms, date, fetchStudents, fetchRoutines]);

  useEffect(() => {
    if (classrooms.length > 0) {
      updateRoutineList();
    }
  }, [updateRoutineList, updateList]);

  // Limpar turma selecionada quando o ano letivo mudar
  useEffect(() => {
    setClassrooms([]);
  }, [anoLetivo]);

  return (
    <>
      <SelectionArea>
        <SelectDate date={date} setDate={setDate} />
        <SelectSys anoLetivo={anoLetivo} setAnoLetivo={setAnoLetivo} />
        <ClassroomSelect
          classrooms={classrooms}
          setClassrooms={setClassrooms}
          anoLetivo={anoLetivo}
          filterIntegralOnly={true}
        />
      </SelectionArea>

      {loading && <Loading />}

      {classrooms.length > 0 && (
        <StudentsList>
          {students.length > 0 &&
            students.map((item, index) => {
              // Converter ambos para string para garantir comparação correta
              const alunoIDStr = String(item.AlunoID);
              const studentPartialDataList = partialData.filter(
                (student) => String(student.idSponte) === alunoIDStr
              );
              const studentPartialData = studentPartialDataList.length > 0 
                ? studentPartialDataList[0] 
                : null;

              return (
                <IntegranteItem
                  key={`student_${item.AlunoID}_${index}_${item.NumeroChamada || ''}`}
                  student={item}
                  status={Boolean(studentPartialData)}
                  date={date}
                  editData={studentPartialData}
                  upadateList={updateList}
                  setUpdateList={setUpdateList}
                />
              );
            })}
        </StudentsList>
      )}
    </>
  );
};

